export const getCookie = cname => {
    let name = `${cname}=`,
        ca = document.cookie.split(';'),
        i,
        c,
        ca_length = ca.length;
    for (i = 0; i < ca_length; i += 1) {
        c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) !== -1) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
};

export const setCookie = (name, value, domain, expires_seconds) => {
    if (!domain) {
        domain = 'trainheroic.com';
    }
    // If no seconds provided, default to a day
    if (!expires_seconds) {
        expires_seconds = 60 * 60 * 24;
    }
    let d = new Date();
    d = new Date(d.getTime() + 1000 * expires_seconds);
    // eslint-disable-next-line
    document.cookie = `${name}=${value};domain=${domain}; expires=${d.toGMTString()};path=/`;
};
